import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { usePaddleCustomerSelection } from './hooks';

type PaddleCustomersDropdownProps = {
  label?: string;
};

export const PaddleCustomersDropdown: React.FC<PaddleCustomersDropdownProps> = ({
  label = 'Paddle Customer',
}) => {
  const { selectedCustomer, paddleCustomers, isFetching, handleInputChange, handleCustomerChange } =
    usePaddleCustomerSelection();

  return (
    <Autocomplete
      options={paddleCustomers ?? []}
      getOptionLabel={(option) => option.name}
      value={selectedCustomer}
      onChange={handleCustomerChange}
      onInputChange={handleInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Paddle Customer"
          slotProps={{
            ...params.slotProps,

            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isFetching && <CircularProgress color="inherit" size={20} />}
                  {params.slotProps.input.endAdornment}
                </>
              ),
            },

            inputLabel: {
              shrink: true,
            }
          }} />
      )}
    />
  );
};
